export default __webpack_public_path__ + "static/media/wz.4d47b5aa.jpg";